export default __webpack_public_path__ + "static/AssessmentImpressions-0a4315dcc76b06222fa31b90b8f4d35a.png";